<mat-card class="cb-margin flex-row flex">
    <mat-card-content class="flex-col flex flex-fill" *cbWaitFor="mappedItem">
        @if (!mappedItem.isCancelled()) {
            <div class="end-end flex-row flex">
                <button
                    mat-raised-button
                    color="primary"
                    class="cb-margin-right-2x"
                    (cbClick)="dialog(undefined)"
                    [disabled]="!projectReleaseStagePermissions.canEdit()"
                >
                    Add
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    (cbClick)="addAll()"
                    [disabled]="!projectReleaseStagePermissions.canEdit()"
                >
                    Reset
                </button>
            </div>
        }
        <cb-table
            *cbWaitFor="mappedItem"
            class="cb-margin-top-3x cb-margin-bottom-3x flex"
            [loaded]="loaded"
        >
            <thead cbTableHead>
                <tr>
                    <td>Trade</td>
                    <td>Business Account</td>
                    <td></td>
                </tr>
            </thead>
            <tbody cbTableBody>
                @for (defaultSupplier of mappedItem.defaultSuppliers; track defaultSupplier) {
                    <tr>
                        <td>{{ defaultSupplier.tradeType.path }}</td>
                        <td>{{ defaultSupplier.supplier.label }}</td>
                        <td class="actions">
                            @if (!mappedItem.isCancelled()) {
                                <button mat-icon-button (cbClick)="dialog(defaultSupplier, $index)">
                                    <mat-icon class="material-icons">edit_mode</mat-icon>
                                </button>
                            }
                            @if (!mappedItem.isCancelled()) {
                                <button
                                    mat-icon-button
                                    (cbClick)="deleteClick(defaultSupplier, $index)"
                                >
                                    <mat-icon class="material-icons">delete</mat-icon>
                                </button>
                            }
                        </td>
                    </tr>
                }
                @if (
                    !mappedItem.defaultSuppliers.length || mappedItem.defaultSuppliers.length < 1
                ) {
                    <tr>
                        <td colspan="3">
                            <cb-info-message
                                [message]="'There are no Default Installers to display'"
                                [icon]="'info_circle'"
                                iconClass="cb-accent"
                            ></cb-info-message>
                        </td>
                    </tr>
                }
            </tbody>
        </cb-table>
    </mat-card-content>
</mat-card>
